import { EPaymentStatus, getPaymentStatus } from '../../../services/billingPayments';
import { TThunkAction } from '../../../../common/types/thunk';
import { EPaymentProvider } from '../../../../PaymentWidgetMicrofrontend';

interface IParams {
  onChangePaymentStatus(status: EPaymentStatus): void;
  provider: EPaymentProvider;
  paymentId: string;
}

const threeSeconds = 3 * 1000;

export const checkPaymentStatus =
  (params: IParams): TThunkAction<Promise<EPaymentStatus>> =>
  async (dispatch, getState, { httpApi }) => {
    const { onChangePaymentStatus, paymentId, provider } = params;

    dispatch(onChangePaymentStatus(EPaymentStatus.Pending));

    const { status } = await getPaymentStatus({ httpApi, paymentId, provider });

    if (status === EPaymentStatus.Pending) {
      return new Promise(resolve => {
        setTimeout(() => {
          const result = dispatch(checkPaymentStatus({ onChangePaymentStatus, paymentId, provider }));

          resolve(result);
        }, threeSeconds);
      });
    }

    dispatch(onChangePaymentStatus(status));

    return Promise.resolve(status);
  };
